import axios from 'axios'

export default {
  methods: {
    /**
     * Change app locale
     *
     * @param {String} locale
     */
    setLocale (locale) {
      this.$root.$i18n.locale = locale
      axios.defaults.headers.common['Accept-Language'] = locale
      document.querySelector('html').setAttribute('lang', locale)
    },

    /**
     * Return data in promise
     *
     * @param {Object} data
     * @param {*Number} milliseconds
     * @returns {Promise}
     */
    resolveWith (data, milliseconds = 300) {
      return new Promise((resolve) => setTimeout(() => resolve({ data }), milliseconds))
    }
  }
}
